<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">日志管理</el-breadcrumb-item>
                <el-breadcrumb-item>业务日志</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="search-layout">
            <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>

        <div class="column-layout">
            <div class="table-layout">
                <el-table :data="bizLogList" border style="width: 100%">
                    <el-table-column prop="comName" label="所属部门" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bizUnitName" label="所属业务单元"  width="130" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="userName" label="用户名称" width="130" align="center"></el-table-column>
                    <el-table-column prop="scopeName" label="范围名称" width="100" align="center"></el-table-column>
                    <el-table-column prop="action" label="访问动作" width="200" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="sysName" label="系统名称" width="150" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="devIp" label="IP地址" width="120" align="center"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="160" align="center"></el-table-column>
                    <el-table-column label="操作" align="left" width="120">
                        <template slot-scope="rows">
                            <a class="swb-btn swb-btn-link" @click="showDialog(rows.row.id)">查看</a>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-layout">
                    <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'

    import servicerApi from '../../api/servicer'

    import SwbBizLogInfo from './BizLogInfo';
    Vue.regist(SwbBizLogInfo);

    let mockConfigData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "label": "所属部门",
            "code": "comName",
            "dataLabel": "text",
            "dataValue": "code",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "所属业务部门",
            "code": "bizUnitName",
            "dataLabel": "text",
            "dataValue": "code",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "用户名称",
            "code": "userName",
            "dataLabel": "text",
            "dataValue": "code",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "IP地址",
            "code": "devIp",
            "dataLabel": "text",
            "dataValue": "code",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "访问动作",
            "code": "action",
            "dataLabel": "text",
            "dataValue": "code",
            "basic": true
        }, {
            "type": "Date2",
            "valueType": "String",
            "label": "创建时间",
            "code": "createTime",
            "basic": true
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-servicer-biz-log-list',
        path: '/bi/log/list',
        pathOld: '/servicer/biz/log/list',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '业务日志列表',
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                bizLogList: [],
                //
                queryConfig: mockConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.getBizLogList();
        },
        methods: {
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.getBizLogList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getBizLogList();
            },
            getBizLogList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                servicerApi.getServcerBizLogList(postData, function (result) {
                    theLoad.close();
                    if(result.type == "info") {
                        self.bizLogList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            showDialog: function (id) {
                let theDlg = Vue.$showDialog({
                    title: "日志详细信息",
                    showCloseBtn: true,
                    width: 700,
                    height: 520,
                    cancelVisible: false,
                    okText: '知道了',
                    template: '<swb-biz-log-info :id="id" ref="swb_biz_log_info"></swb-biz-log-info>',
                    data: {
                        id: id,
                    },
                    okClicked: function () {
                        theDlg.close();
                    },
                    methods: {},
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizLog/ServicerBizLogList.vue